import React from 'react';
import { useNavigate } from 'react-router';
import { cn } from '@bem-react/classname';
import { Delete, Pen } from 'assets';
import { Event } from 'store/reducer/events';

import { TableItem } from 'components';

import './EventsTableItem.scss';

const CnEventsTableItem = cn('eventsTableItem');

type IEventsTableItemProps = Event;

export const EventsTableItem: React.FC<IEventsTableItemProps> = ({ id, name, trigger,description,templates,templateGroup,conditions }) => {
    const navigate = useNavigate();

    const deleteGroupHandler = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
        navigate('?modal=delete-event', {
            state: {
                id,
                name,
            },
        });
    };

    const changeGroupHandler = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();

        navigate('?modal=change-event', {
            state: {
                id,
                name,
                trigger,
                description,
                templates,
                templateGroup,
                conditions
            },
        });
    };

    return (
        <tr>
            <TableItem>{name}</TableItem>
            <TableItem>{trigger}</TableItem>
            <TableItem>{description}</TableItem>
            <TableItem>{templates!=null || templateGroup?.name!=''?templates?.length:0}</TableItem>
            {/*<TableItem>{templateGroup?.name!='' || templates!=null ?templateGroup?.name:"отсутсвует"}</TableItem>*/}
            <TableItem>
                <div className={CnEventsTableItem('actions')} >
                    <div onClick={changeGroupHandler} className={CnEventsTableItem('action')}>
                        <Pen className={CnEventsTableItem('icon')} />
                        Изменить
                    </div>

                    <div className={CnEventsTableItem('action')} onClick={deleteGroupHandler}>
                        <Delete className={CnEventsTableItem('icon')} />
                        Удалить
                    </div>

                </div>
            </TableItem>
        </tr>
    );
};
